<template>
    <div class="all">
        <van-nav-bar
                :title="title"
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
                @click-right
                :border="border"
        />
        <div class="showContent">
            <!-- #######################基本信息####################### -->
            <template v-if="this.$route.params.active=='0'">
                <van-row v-if="personData.roleName!='店员'">
                    &nbsp;推 荐 码 ：<span>{{personData.inviteCode}}</span>
                    <p>(此推荐码用于您的下级代理推广)</p>
                </van-row>
                <van-row>
                    &nbsp;手 机 号 ：{{personData.contactPhone}}
                </van-row>
                <van-cell-group>
                    <div>
                        <van-field
                                v-model="personData.traderName"
                                clearable
                                label="真实姓名:"
                                placeholder="请输入真实姓名"
                        />

                        <van-field
                                v-model="personData.storeName"
                                label="门店名称:"
                                placeholder="请输入门店名称"
                        />

                        <van-field
                                :value="address"
                                @click="addressClick()"
                                label="门店地址:"
                                placeholder="请选择省市区"
                        />

                        <van-field v-model="personData.contactAddress" placeholder="详细xx路xx号" label="详细地址:"/>
                    </div>
                </van-cell-group>
                <van-row>
                    所属角色：{{personData.roleName}}
                </van-row>
                <van-row>
                    注册时间：{{personData.registerDate}}
                </van-row>
                <van-row>
                    上一级账号：{{personData.pName}}
                </van-row>
                <div class="personButton">
                    <van-button round type="default" size="small" @click="updatePerson()">保存个人信息</van-button>
                </div>
                <van-popup v-model="show" position="bottom">
                    <van-area :area-list="areaList" value="110101" title="地 址" :item-height="itemHeight"
                              @cancel="cancel"
                              @confirm="confirm"/>
                </van-popup>
            </template>

            <!-- #################收款信息############### -->
            <template v-else-if="this.$route.params.active=='1'">
                <div v-if="personData.payeeInfoTplList.length>0">
                  <van-tabs v-model="tabIndex" @change="cashBankFormChange" color="#ee9900" :border="false">
                      <van-tab v-for="(tpl,index) in personData.payeeInfoTplList" :name="index" :title="tpl.typeName" :key="index">
                      </van-tab>
                  </van-tabs>

                  <div class="finance" v-if="cashBankFormTpl.fieldList">
                        <van-field
                            v-model="cashBankForm[item.field]"
                            clearable
                            :label="item.fieldName"
                            :placeholder="item.fieldDesc"
                             v-for="(item,index) in cashBankFormTpl.fieldList" :key="index"
                        />
                  </div>

                  <div class="buttom">
                      <van-button size="large" round @click="financeSave()">保存</van-button>
                  </div>
                </div>
                <div v-if="showNoContent" class="noConent">
                    系统暂未配置需要绑定的收款账户 ~
                </div>
            </template>


            <!--####################邀请信息####################-->
            <template v-else-if="this.$route.params.active=='2'">
                <div class="invitation" :style="'background-image:url('+personData.inviteBackgroundImgUrl+'); background-size: 100% auto;'">
                    <div class="middle">
                        <p><strong>{{personData.roleName}}_{{personData.traderName}}</strong>，您的邀请码是<strong>{{personData.inviteCode}}</strong>
                        </p>
                        <p>您可以邀请注册<strong>{{personData.lowerRoleName}}</strong>加盟
                        </p>
                        <div class="showCode">
                            <vue-qr :logoSrc="youtui" :margin="0" :text="personData.wapInviteLink" :logoScale="0.25"
                                    :size="200"></vue-qr>

                            <van-button round size="normal" v-clipboard:copy=personData.wapInviteLink
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onError">复制分享链接
                            </van-button>
                        </div>
                    </div>
                </div>
            </template>

            <!--####################实名认证####################-->
            <template v-else-if="this.$route.params.active=='3'">
                <realName></realName>
            </template>

        </div>
    </div>
</template>

<script>
    import userAPI from '@/api/user'
    import youtui from '@/assets/images/youtui.png'
    import constantAPI from '@/api/constant'
    import vueQr from 'vue-qr'
    import realName from './components/realName'

    export default {
        components: {
            vueQr,
            realName
        },
        data() {
            return {
                youtui: youtui,
                itemHeight: 40,
                show: false,
                urlShow: false,
                showcancel: true,
                readonly: false,
                border: false,
                active: 0,
                title: '',
                shareUrl: '',
                personData: {
                  cashBankInfoMap:{},
                  payeeInfoTplList: [],
                  province:'',
                  city:'',
                  area:'',
                  roleName:'',
                  inviteCode:'',
                  contactPhone:'',
                  traderName:'',
                  storeName:'',
                  contactAddress:'',
                  roleName:'',
                  registerDate:'',
                  pName:'',
                  lowerRoleName:'',
                  wapInviteLink: "",
                  inviteBackgroundImgUrl: '',
                },
                showNoContent:false,
                selectArea: [],
                areaList: {},
                cashBankForm: {type:''},
                cashBankFormTpl:{},
                tabIndex:0
            }
        },
        computed:{
            address:function () {
                if (this.personData)
                return this.personData.province + this.personData.city + this.personData.area
                else
                return ''
            }
        },
        created() {
            this.active = this.$route.params.active
            switch (this.active) {
                case '0':
                    this.getArea()
                    this.title = '基本信息'
                    this.getPerson()
                    break
                case '1':
                    this.title = '财务信息'
                    this.getPerson()
                    break
                case '2':
                    this.title = '邀请信息'
                    this.getPerson()
                    break
                case '3':
                    this.title = '实名认证';
                    break
            }
        },
        methods: {
            //获取个人资料
            getPerson() {
                this.$toast.loading({forbidClick:true})
                userAPI.show().then(result => {
                    this.personData = result.data;
                    if (this.personData&&this.personData.payeeInfoTplList) {
                        if (this.personData.payeeInfoTplList.length > 0 ) {
                          if(this.$route.query.type){
                            for(let i=0;i<this.personData.payeeInfoTplList.length;i++){
                              if(this.$route.query.type==this.personData.payeeInfoTplList[i].type){
                                this.tabIndex = i
                                this.cashBankFormChange(this.tabIndex)
                                break;
                              }
                            }
                          }else{
                            this.tabIndex = 0
                            this.cashBankFormChange(this.tabIndex)
                          }
                        }else{
                            this.showNoContent = true
                        }
                    }else{
                        this.showNoContent = true
                    }
                    this.$toast.clear()
                })
            },
            //提现账户切换
            cashBankFormChange(index) {
                this.cashBankFormTpl = this.personData.payeeInfoTplList[index]
                let type = this.cashBankFormTpl.type
                if (this.personData.cashBankInfoMap[type]) {
                  this.cashBankForm = JSON.parse(JSON.stringify(this.personData.cashBankInfoMap[type]))
                } else {
                   let cashBankInfo = {type:type}
                   this.cashBankForm = cashBankInfo
                }
            },
            //得到省市信息
            getArea() {
                constantAPI.areaList().then((result) => {
                    this.areaList = result.data
                })
            },
            //修改个人资料
            updatePerson() {
                userAPI.updatePerson(this.personData).then((result) => {
                    this.$toast.success('修改成功')
                    this.getPerson();
                }).catch(() => {
                })
            },
            //修改绑定收款信息
            financeSave() {
                if(!this.cashBankForm.type){
                  this.$toast.fail('必须选择绑定收款账户类型');
                  return
                }
                userAPI.cashBankBind(this.cashBankForm).then((result) => {
                    this.$toast.success('保存成功')
                    this.getPerson()
                }).catch(() => {
                })
            },
            newPass(e) {
                if (e == 3) {
                    this.$router.push('/newPassword')
                }
            },
            addressClick() {
                this.show = true
                this.overlay = true
            },
            cancel() {
                this.show = false
            },
            confirm(e) {
                this.selectArea = e
                if (this.selectArea[0].name == this.selectArea[1].name) {
                    this.personData.city = this.selectArea[1].name;
                    this.personData.area = this.selectArea[2].name;
                } else {
                    this.personData.province = this.selectArea[0].name;
                    this.personData.city = this.selectArea[1].name;
                    this.personData.area = this.selectArea[2].name;
                }
                this.show = false
            },
            onError() {
                this.$toast.fail('复制失败')
            },
            onCopy() {
                this.$toast.success('分享链接已经复制到剪切板')
            },
        },
    }
</script>

<style lang="scss" scoped>

    .all {
        background-color: #fff;
    }

    .showContent {
        .van-row {
            font-size: 1.2rem;
            margin: 1rem 1rem 0.5rem 1rem;
            span {
                color: #f40;
            }

            p {
                color: #bfbfbf;
            }
        }

    }

    .personButton {
        .van-button {
            margin-top: 10%;
            left: 30%;
            background-color: #ee9900;
            color: #fff;
        }
    }

    .finance {
        margin:3rem 1rem;
        .van-field{
          margin:1rem;
        }
    }

    .invitation {
        text-align: center;
        padding: 10rem 1rem 10rem 1rem;
        font-size: 1.1rem;

        .middle {
            background-color: #fff;
            margin: auto 8% auto 8%;
            padding: 1rem 0.5rem;
            border-radius: 1rem;
        }

        .showCode {
            margin: 2rem 15%;
        }
        strong {
            color: #ee9900;
        }

        .van-button {
            margin-top: 2rem;
            background-color: #ee9900;
            color: #FFFFFF;
            padding: 0rem 4rem;
        }

        /*span {*/
            /*display: block;*/
            /*width: 100%;*/
            /*overflow: scroll;*/
        /*}*/

    }

    .buttom {
        margin: 0.5rem 2rem;
        .van-button {
            margin-top: 10%;
            background-color: #ee9900;
            color: #fff;
        }
    }

    .noConent{
      margin: 4rem auto;
      padding: 1rem;
      text-align: center;
      font-size: 1.2rem;
      color: #8b8b8b;
      a {
          font-size: 1.2rem;
          text-decoration: underline;
          color: #ee9900;
      }
    }
</style>
